/* global $ */

const SPINNER_SELECTOR = '.js-ajax-spinner'

export default class AjaxSpinnerWidget {
  showSpinner() {
    $(SPINNER_SELECTOR).removeClass('ajax-spinner--inactive')
  }

  hideSpinner() {
    $(SPINNER_SELECTOR).addClass('ajax-spinner--inactive')
  }
}
